// Shown only while the newest poll failed: the wall keeps the last good catalog and
// says how old it is, rather than blanking or showing an error (build-guide §6).
export function StaleStamp({ at }: { at: number | null }) {
  if (at === null) return null
  const d = new Date(at)
  const hh = ('0' + d.getHours()).slice(-2)
  const mm = ('0' + d.getMinutes()).slice(-2)
  return (
    <div className="absolute right-0 bottom-0 font-secondary font-normal text-[18px] leading-none text-gray-400">
      {'prices as of ' + hh + ':' + mm}
    </div>
  )
}
